import { useEffect, useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import VisitsResponses from "./Visits/VisitsResponses";
import CategoryTabs from "./CategoryTabs";
import { useParams } from "react-router-dom";
import Query from "./Queries/Query";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { resetResponseState } from "../../Redux/reducers/responseSlice";
import RepeatingResponses from "./RepeatingData/RepeatedResponses";
import Randomization from "./Randomization/Randomization";
import Survey from "./Survey/Survey";
import { fetchParticipantById } from "../../Redux/actions/responseAction";
import FormHeader from "./FormHeader";
import ConfirmationModalWrapper from "./ConfirmationModalWrapper";
import { featuresMap } from "../../utils/features";
import CalculationWrapper from "./CalculationWrapper/CalculationWrapper";
// import Documents from "./Documents/Documents";
import ScreeningResponses from "./Screening/ScreeningResponses";
import ParticipantDocuments from "./ParticipantDocuments/ParticipantDocuments";
import { canShowSurveysTab } from "../../utils/surveyEligibility";

const Responses = () => {
  const dispatch = useAppDispatch();
  const { id: studyId, participantId } = useParams();
  const features = useAppSelector((state) => state.study.features);
  const checkingPermissions = useAppSelector(
    (state) => state.response.checkingPermissions
  );
  const viewRandomization = useAppSelector(
    (state) => state.response.viewRandomization
  );
  const toggleLoader = useAppSelector((state) => state.response.toggleLoader);
  const currentCategory = useAppSelector(
    (state) => state.response.currentCategory
  );
  const eligibilityStatus = useAppSelector(
    (state) => state.response.eligibilityStatus
  );

  // const [currentCategory, setCurrentCategory] = useState<string>(
  //   getDefault(features, sessionStorage?.getItem("response-view") ?? "visit")
  // );
  const [showModal, setShowModal] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);

  useEffect(() => {
    if (studyId && participantId)
      dispatch(fetchParticipantById(studyId, participantId));
  }, [dispatch, studyId, participantId, toggleLoader]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("response-view");
      sessionStorage.removeItem("response-visit-form");
      sessionStorage.removeItem("response-repeated-form");
      sessionStorage.removeItem("response-visit-question");
      sessionStorage.removeItem("response-repeated-question");
      dispatch(resetResponseState());
    };
  }, [dispatch]);

  return (
    <>
      {checkingPermissions ? (
        <Stack
          sx={{
            flex: 1,
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <CircularProgress color="primary" />
        </Stack>
      ) : (
        <Stack>
          <FormHeader
            setShowModal={setShowModal}
            setChangeStatus={setChangeStatus}
          />

          <CategoryTabs />

          {currentCategory === "screening" && features?.[featuresMap.visit] && (
            <ScreeningResponses
              showModal={showModal}
              setShowModal={setShowModal}
              changeStatus={changeStatus}
              setChangeStatus={setChangeStatus}
            />
          )}
          {currentCategory === "visit" && features?.[featuresMap.visit] && (
            <VisitsResponses />
          )}
          {currentCategory === "repeated_data" &&
            features?.[featuresMap.repeatedData] && <RepeatingResponses />}
          {currentCategory === "randomization" &&
            viewRandomization &&
            features?.[featuresMap.randomization] && <Randomization />}

          {currentCategory === "surveys" &&
            features?.[featuresMap.survey] &&
            canShowSurveysTab(eligibilityStatus) && (
            <Survey showModal={showModal} setShowModal={setShowModal} />
          )}
          {currentCategory === "documents" && (
            <ParticipantDocuments
              showModal={showModal}
              setShowModal={setShowModal}
            />
          )}
          <Query />
          <ConfirmationModalWrapper />
          <CalculationWrapper />
        </Stack>
      )}
    </>
  );
};

export default Responses;
